defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/FixedDeposit',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, Utils, Loader, CardContent, CtaButton) {
    var FixedDeposit = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
        this.loading = m.prop(true);

        if (!this.play()) {
          this.error(this.rootDictionary.get('ErrorMessages/GENERIC_ERROR'));
          return;
        }

        this.pageTitle(this.dictionary('DepositTypeFixed/PageTitle'));
        this.pageDescription(controller.dictionary('DepositTypeFixed/PageDescription' + this.multiWagerSuffix(), { WEEKS: this.play().numberOfDraws, DRAWS: controller.play().numberOfDraws }));

        const gameTypePathsMap = {
          lotto: 'Lotto',
          eurojackpot: 'Eurojackpot',
          vikinglotto: 'VikingLotto'
        };
        const gameTypePath = gameTypePathsMap[this.gameType().toLowerCase()];
        requireDs('DanskeSpil/Domain/' + gameTypePath + '/Scripts/Models/' + gameTypePath + 'Game', (GameModel) => {
          this.game(GameModel.setupGame({
            playType: this.playType,
            numberOfDraws: this.play().numberOfDraws,
            rowsToGenerate: this.play().fixedRowCount,
            playTogetherDepositType: this.depositType
          }));
          this.useCampaignEngineInit();

          this.loading(false);
          m.redraw();
        });
      },
      view: function (controller) {
        const $content = () => {
          if (controller.loading()) {
            return Loader(controller);
          }

          // multiwager eurojackpot has draws and not weeks
          const isEurojackpot = controller.gameType() === 'eurojackpot';

          return m('.play-together-fixed-deposit__wrapper', [
            m('.play-together-fixed-deposit__row', [
              m('.play-together-fixed-deposit__column', [
                m('.play-together-fixed-deposit__column-title', controller.dictionary('DepositTypeFixed/RowsTitle')),
                m('.play-together-fixed-deposit__card', [
                  m('.play-together-fixed-deposit__card-value', controller.play().fixedRowCount),
                  m('.play-together-fixed-deposit__card-label', controller.dictionary('DepositTypeFixed/RowsLabel'))
                ])
              ]),
              m('.play-together-fixed-deposit__column', [
                m('.play-together-fixed-deposit__column-title', controller.dictionary('DepositTypeFixed/WeeksTitle')),
                m('.play-together-fixed-deposit__card', [
                  m('.play-together-fixed-deposit__card-value', controller.play().numberOfDraws),
                  m('.play-together-fixed-deposit__card-label', controller.dictionary(isEurojackpot ? 'DepositTypeFixed/DrawsLabel' : 'DepositTypeFixed/WeeksLabel'))
                ])
              ])
            ]),
            controller.property('campaignTicketCounter')?.({ rows: controller.play().fixedRowCount }),
            controller.property('specialCampaignTicketCounter')?.({ rows: controller.play().fixedRowCount })
          ]);
        };

        const $footer = controller.loading() ? null : [
          CtaButton({
            text: controller.subscriptionGroupGameId() ? controller.rootDictionary.get('ChooseWeeks/GoToPlayAsSubscriptionButton') : controller.dictionary('BuyInButton', { price: Utils.formatCurrency(controller.game().totalPrice()) }),
            onClick: controller.action,
            loading: controller.processing(),
            options: ['primary', 'big']
          })
        ];

        const className = () => {
          let name = '';

          if (controller.useCampaignFlowGraphics() &&
            controller.drawsInCampaignCount()) {
            name = 'campaign-theming';
          }

          return name;
        };

        return CardContent({
          className: className(),
          $content: $content(),
          $footer: $footer
        });
      }
    };

    // Public functions:
    return FixedDeposit;
  });
